import Game from 'Game';
import { LoadEvents, LoadEventType, LoadtimeTrackerSingleton } from 'Utility/LoadtimeTracker';
import { failedToConnectToGBC } from './FailedToConnectToGBC';
import { handleGBCConnected } from './HandleGBCConnected';

export async function connectToGBC() {
    LoadtimeTrackerSingleton.trackLoadTask(LoadEvents.GB_loginFlow, LoadEventType.Start);

    const promise = Game.sdk.connectToGBC().then(handleGBCConnected, failedToConnectToGBC);

    await promise;
}
